import React, { useState, useEffect, useRef } from 'react';
import { useCallback } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import {useReactToPrint} from 'react-to-print';
import './LawPage.css';
import { FaRegFileAlt } from "react-icons/fa";
import { LuTag } from "react-icons/lu";
import { BsBookmarks } from "react-icons/bs";
import { BsCalendar2Date } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { IoPrintOutline } from "react-icons/io5";
import logo from '../../assest/images/logoAlbarede.png';
import footer from '../../assest/images/footer-print.png';
import { BsShare } from 'react-icons/bs'

// هذه الدالة تم تفعيلها لتمرير مصطلح البحث
function highlightSearchTerm(text, term) {
    if (!term || !text) return text;

    const regex = new RegExp(`(${term})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) => {
        // إذا كان الجزء يطابق مصطلح البحث (تم التقسيم بواسطة regex)
        if (part.toLowerCase() === term.toLowerCase()) {
            return (
                <span
                    key={index}
                    className="highlight"
                    // إضافة نمط التظليل المباشر بناءً على طلب المستخدم
                    style={{ backgroundColor: '#fbe08d', color: '#1f2937', fontWeight: 'bold' }}
                >
                    {part}
                </span>
            );
        }
        return part;
    });
}


function formatArticleText(text, searchTerm) {
    if (!text) return null;

    const lines = text.split('\n');
    let output = [];
    let currentList = null;
    let isUl = false;

    lines.forEach((line, index) => {
        const trimmedLine = line.trim();
        if (!trimmedLine) return;

        const isLetteredOl = /^- *[أ-ي]\s*-/.test(trimmedLine);
        const isNumberedOl = /^- *\d+\s*-/.test(trimmedLine);
        const isBulletUl = /^- *\s*\-/.test(trimmedLine);

        if (isLetteredOl || isNumberedOl || isBulletUl) {
            const cleanText = trimmedLine.replace(/^- *(\s*\-|\d+|\w+)\s*-/, '').trim();

            if (!currentList || (isBulletUl && !isUl) || (!isBulletUl && isUl)) {
                if (currentList) {
                    output.push(currentList);
                }
                isUl = isBulletUl;
                currentList = isUl ? <ul key={`list-${index}`}></ul> : <ol key={`list-${index}`}></ol>;
            }

            // تطبيق التظليل على محتوى قائمة العناصر
            // ملاحظة: تم تعديل هذا الجزء ليتوافق مع تحديثاتك السابقة
            const newLi = <li key={index}>{highlightSearchTerm(cleanText, searchTerm)}</li>;
            currentList.props.children.push(newLi);

        } else {
            if (currentList) {
                output.push(currentList);
                currentList = null;
            }
            // تطبيق التظليل على الفقرات العادية
            output.push(<p key={index}>{highlightSearchTerm(trimmedLine, searchTerm)}</p>);
        }
    });

    if (currentList) {
        output.push(currentList);
    }

    if (output.length === 0) {
        return <p>{highlightSearchTerm(text, searchTerm)}</p>;
    }

    return output;
}

function LawPage() {
    // 1. جلب ID القانون من المسار (URL)
    const { lawId } = useParams();
    const navigate = useNavigate();
    const [shareMessage, setShareMessage] = useState({ visible: false, text: '', type: 'success' });
    
    // 2. حالات تخزين البيانات وحالة التحميل والخطأ
    const [lawDetails, setLawDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [articleSearchTerm, setArticleSearchTerm] = useState('');
    const componentRef = useRef();
    
    const handlePrint = useReactToPrint({
        documentTitle: 'Title',
        contentRef: componentRef,
        })
    console.log(componentRef.current)

    
    const handleShare = useCallback((lawTitle, lawId) => {
            const shareUrl = `${window.location.origin}/law/${lawId}`;
            const shareText = `قانون: ${lawTitle}`;
    
            const showToast = (text, type = 'success') => {
                setShareMessage({ visible: true, text, type });
                setTimeout(() => setShareMessage({ visible: false, text: '', type: 'success' }), 3000);
            };
    
            if (navigator.share) {
                navigator.share({
                    title: lawTitle,
                    text: shareText,
                    url: shareUrl,
                }).catch(error => {
                    if (error.name !== 'AbortError') {
                        console.error('Error sharing:', error);
                        showToast('فشل المشاركة.', 'error');
                    }
                });
            } else {
                // Fallback: Copy URL to clipboard
                try {
                    // استخدام API الحديث للنسخ مع محاولة الرجوع للطرق القديمة
                    navigator.clipboard.writeText(shareUrl)
                        .then(() => showToast('تم نسخ الرابط!'))
                        .catch(() => {
                            // Fallback (document.execCommand('copy'))
                            const dummyElement = document.createElement("textarea");
                            dummyElement.value = shareUrl;
                            document.body.appendChild(dummyElement);
                            dummyElement.select();
                            document.execCommand("copy");
                            document.body.removeChild(dummyElement);
                            showToast('تم نسخ الرابط!');
                        });
                } catch (error) {
                    console.error("Clipboard API failed:", error);
                    showToast('فشل نسخ الرابط.', 'error');
                }
            }
        }, []);

        
    const filterArticles = (law, term) => {
        if (!law) return null;
        if (!term) return law;

        const lowerCaseTerm = term.toLowerCase().trim();
        // نمط للبحث عن رقم المادة بالتحديد (مثل '2', 'المادة 2', 'مادة 2')
        const articleNumberRegex = /^(?:المادة\s*|مادة\s*|)(\d+)\s*$/;
        const numberMatch = lowerCaseTerm.match(articleNumberRegex);
        const isNumberSearch = numberMatch && numberMatch[1];

        const lowerCaseNumberTerm = isNumberSearch ? numberMatch[1] : lowerCaseTerm;

        // 1. تصفية الفصول والمواد داخلها
        const filteredChapters = law.chapters ? law.chapters.map(chapter => {
            const filteredChapterArticles = chapter.articles.filter(article => {
                const articleTextLower = article.article_text.toLowerCase();
                const articleNumberString = article.article_number.toString();

                // الشرط 1: تطابق رقم المادة بشكل دقيق (إذا كان البحث رقمًا)
                if (isNumberSearch && articleNumberString === lowerCaseNumberTerm) {
                    return true;
                }

                // الشرط 2: تطابق النص العادي (في النص أو رقم المادة)
                if (articleTextLower.includes(lowerCaseTerm) || articleNumberString.includes(lowerCaseTerm)) {
                    return true;
                }

                return false;
            });

            return {
                ...chapter,
                articles: filteredChapterArticles,
            };
        }).filter(chapter => chapter.articles.length > 0) : [];

        // 2. تصفية المواد المستقلة (إذا لم يكن هناك فصول)
        const filteredArticles = law.articles ? law.articles.filter(article => {
            const articleTextLower = article.article_text.toLowerCase();
            const articleNumberString = article.article_number.toString();

            // الشرط 1: تطابق رقم المادة بشكل دقيق (إذا كان البحث رقمًا)
            if (isNumberSearch && articleNumberString === lowerCaseNumberTerm) {
                return true;
            }

            // الشرط 2: تطابق النص العادي
            if (articleTextLower.includes(lowerCaseTerm) || articleNumberString.includes(lowerCaseTerm)) {
                return true;
            }

            return false;
        }) : [];

        // إرجاع بنية القانون المصفاة
        return {
            ...law,
            chapters: filteredChapters,
            articles: filteredArticles
        };
    };

    // تطبيق التصفية
    const filteredLawDetails = filterArticles(lawDetails, articleSearchTerm);
    // 3. دالة جلب البيانات
    useEffect(() => {
        if (!lawId) {
            setError("لم يتم تحديد رقم القانون.");
            setLoading(false);
            return;
        }
        const fetchLawDetails = async () => {
            setLoading(true);
            try {
                // const response = await axios.get(`http://localhost/server/testServer/get_law_details.php?id=${lawId}`);
                const response = await axios.get(`https://www.albarede.com/server/get_law_details.php?id=${lawId}`);
                const data = response.data;
                if (data && data.law_details) {
                    let lawDetailsData = data.law_details;
                    if (lawDetailsData.chapters && Array.isArray(lawDetailsData.chapters)) {
                        lawDetailsData.chapters.sort((a, b) => {
                            const numA = parseInt(String(a.chapter_number).trim(), 10) || 0; 
                            const numB = parseInt(String(b.chapter_number).trim(), 10) || 0;
                            return numA - numB;
                        });
                        //  الحل لفرز المواد عدديًا داخل كل فصل
                        lawDetailsData.chapters = lawDetailsData.chapters.map(chapter => {
                            if (chapter.articles && Array.isArray(chapter.articles)) {
                                chapter.articles.sort((a, b) => {
                                    const artNumA = parseInt(String(a.article_number).trim(), 10) || 0;
                                    const artNumB = parseInt(String(b.article_number).trim(), 10) || 0;
                                    return artNumA - artNumB;
                                });
                            }
                            return chapter;
                        });
                    }
                    if (lawDetailsData.articles && Array.isArray(lawDetailsData.articles)) {
                         lawDetailsData.articles.sort((a, b) => {
                            const artNumA = parseInt(String(a.article_number).trim(), 10) || 0;
                            const artNumB = parseInt(String(b.article_number).trim(), 10) || 0;
                            return artNumA - artNumB;
                        });
                    }
                    setLawDetails(lawDetailsData);
                    setError(null);
                } else {
                    setError("القانون المطلوب غير موجود أو حدث خطأ في جلب البيانات.");
                    setLawDetails(null);
                }
            } catch (err) {
                console.error("Error fetching law details:", err);
                setError("حدث خطأ أثناء الاتصال بالخادم.");
            } finally {
                setLoading(false);
            }
        };

        fetchLawDetails();
    }, [lawId]);

    // 4. عرض حالة التحميل والخطأ
    if (loading) {
        return <div className="law_page_container loading_state">جاري تحميل تفاصيل القانون...</div>;
    }

    if (error) {
        return (
            <div className="law_page_container error_state">
                <button className='back' onClick={() => navigate(-1)}><IoChevronBack /> العودة</button>
                <p className="error_message">{error}</p>
            </div>
        );
    }

    // استخدام المتغير المفلتر فقط عند وجود مصطلح بحث
    const detailsToDisplay = articleSearchTerm ? filteredLawDetails : lawDetails;

    if (!detailsToDisplay) {
        return <div className="law_page_container error_state">بيانات القانون غير متوفرة للعرض.</div>;
    }
    const tagsArray = detailsToDisplay.tags ? detailsToDisplay.tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0) : [];

    
    // 5. عرض البيانات إذا كانت متوفرة
    return (
        <>
            <div className="law_page_container containerNew">
                
                
                {/* تطبيق المرجع على المحتوى المراد طباعته */}
                <div className="printable_content" ref={componentRef}>
                    {/* تفاصيل القانون الرئيسية */}
                    <div className='law_details_printable'>
                        <div className='logo'>
                            <img src={logo} alt='logo' />
                            <p><strong>شركة البريدي للمحاماة</strong>Al Barede Law Firm</p>
                            <span></span>
                        </div>
                        <h3><FaRegFileAlt />  {lawDetails.title}</h3>
                        <div>
                                <span className="meta_item"><LuTag />  رقم: <strong>{lawDetails.law_number}</strong> لعام: <strong>{lawDetails.issue_year}</strong></span>
                                <span className="meta_item"><BsBookmarks />النوع: <strong>{lawDetails.type_name}</strong></span>
                                <span className="meta_item"><BsCalendar2Date />تاريخ الإصدار: <strong>{lawDetails.issue_date}</strong></span>
                            </div>
                            <div>
                                <span className="meta_item">التصنيف: <strong>{lawDetails.category_name}</strong></span>
                                <span className="meta_item">الجهة: <strong>{lawDetails.source_name}</strong></span>
                                <span className={`meta_item law_status ${lawDetails.is_enforced ? 'enforced' : 'not_enforced'}`}>
                                    <strong>{lawDetails.is_enforced ? 'نافذ' : 'ملغى'}</strong>
                                </span>
                            </div>
                    </div>
                    <header className="law_page_header non_print_metadata">
                        <div className='page_titel'>
                            <FaRegFileAlt />
                            <h1 className='running_title'>{lawDetails.title}</h1>
                        </div>
                        <div className="law_metadata">
                            <div>
                                <span className="meta_item"><LuTag />  رقم: <strong>{lawDetails.law_number}</strong> لعام: <strong>{lawDetails.issue_year}</strong></span>
                                <span className="meta_item"><BsBookmarks />النوع: <strong>{lawDetails.type_name}</strong></span>
                                <span className="meta_item running_date"><BsCalendar2Date />تاريخ الإصدار: <strong>{lawDetails.issue_date}</strong></span>
                            </div>
                            <div>
                                <span className="meta_item">التصنيف: <strong>{lawDetails.category_name}</strong></span>
                                <span className="meta_item">الجهة: <strong>{lawDetails.source_name}</strong></span>
                                <span className={`meta_item law_status ${lawDetails.is_enforced ? 'enforced' : 'not_enforced'}`}>
                                    <strong>{lawDetails.is_enforced ? 'نافذ' : 'ملغى'}</strong>
                                </span>
                            </div>
                        </div>
                        <div className='tags'>
                            {tagsArray.map((tag, index) => (
                                <span key={index} className='tag_item'>
                                    #{tag}
                                </span>
                            ))}
                        </div>

                    </header>

                    <div className='law_actions'>
                        {lawDetails && (
                            <button 
                                className="print_button"
                                onClick={handlePrint} 
                                title="طباعة او تحميل pdf"
                            >
                                <IoPrintOutline /> <strong>طباعة/ تحميل pdf</strong>
                            </button>
                        )}
                            <button 
                            className="share_btn" 
                            onClick={() => handleShare(lawDetails.title, lawDetails.id)} 
                            title="مشاركة القانون"
                                >
                            <BsShare /> <strong>مشاركة</strong>
                        </button>
                    </div>
                    <div className="search_bar_law_articles non_print_metadata">
                        <FiSearch />
                        <input
                            type="text"
                            placeholder="ابحث داخل المواد (رقم المادة أو النص)..."
                            value={articleSearchTerm}
                            onChange={(e) => setArticleSearchTerm(e.target.value)}
                            title="ابحث داخل مواد القانون"
                        />
                    </div>


                    {(articleSearchTerm && (!filteredLawDetails || (filteredLawDetails.chapters.length === 0 && filteredLawDetails.articles.length === 0))) && (
                        <div className="no_results_message">
                            لا توجد نتائج بحث مطابقة لعبارة: <strong>{articleSearchTerm}</strong>
                        </div>
                    )}

                    {/* الديباجة/المقدمة */}
                    {!articleSearchTerm && lawDetails.preamble && (
                        <section className="law_preamble">
                            <h2>ديباجة القانون</h2>
                            <div className="preamble_content">
                                {formatArticleText(lawDetails.preamble)}
                            </div>
                        </section>
                    )}

                    {/* فصول ومواد القانون */}
                    <section className="law_content_section">
                        <h2>نص القانون والمواد</h2>
                        {!articleSearchTerm && lawDetails.preamble && (
                            <p className='pre-wrap'>{lawDetails.header_text}</p>
                        )}
                        {/* عرض الفصول (الأقسام الكبرى) - نستخدم filteredLawDetails */}
                        {filteredLawDetails && filteredLawDetails.chapters && filteredLawDetails.chapters.length > 0 ? (
                            filteredLawDetails.chapters.map(chapter => (
                                <div key={chapter.id} className='chapter_block'>
                                    <h3 className="chapter_title_full">{chapter.chapter_title}</h3>

                                    {/* عرض المواد داخل الفصل */}
                                    {chapter.articles && chapter.articles.length > 0 && (
                                        <div className='articles_list'>
                                            {chapter.articles.map(article => (
                                                <div key={article.id} className="article_full_view">
                                                    {/* تظليل رقم المادة إذا كان يطابق (التظليل يختفي في الطباعة) */}
                                                    <h4 className="article_number_full">
                                                        المادة {highlightSearchTerm(article.article_number.toString(), articleSearchTerm)}
                                                    </h4>
                                                    <div className='article_text_full'>
                                                        {/* تظليل نص المادة */}
                                                        {formatArticleText(article.article_text, articleSearchTerm)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            // عرض المواد مباشرة إذا لم يكن هناك فصول - نستخدم filteredLawDetails
                            filteredLawDetails && filteredLawDetails.articles && filteredLawDetails.articles.length > 0 && (
                                <div className='articles_list'>
                                    {filteredLawDetails.articles.map(article => (
                                        <div key={article.id} className="article_full_view">
                                            {/* تظليل رقم المادة إذا كان يطابق */}
                                            <h4 className="article_number_full">
                                                المادة {highlightSearchTerm(article.article_number.toString(), articleSearchTerm)}
                                            </h4>
                                            <div className='article_text_full'>
                                                {/* تظليل نص المادة */}
                                                {formatArticleText(article.article_text, articleSearchTerm)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                        {!articleSearchTerm && lawDetails.preamble && (
                            <p className='pre-wrap'>{lawDetails.footer_text}</p>
                        )}
                        <img className='footer_img' src={footer} alt='footer-Albarede contact' />
                    </section>
                    
                </div> {/* نهاية printable_content */}

            </div>
        </>
    );
}

export default LawPage;